/**
 * Matriz result component.
 */

import { ApplicationContext } from '../../common/context';
import { FormattedMessage } from "react-intl";
import { Icon } from 'antd';
import { number } from 'prop-types';

import React, { useContext } from 'react';

const ResultMatriz = props => {
  const { id } = props;
  const context = useContext(ApplicationContext);
  const prefix = context.isMatrix ? 'matrix' : 'evaluation';

  const result = context.getOption(`${prefix}.form[${id}]`);
  const title = context.getOption(`${prefix}.form[${id}][0]`);

  let statusColor = '';
  let statusIcon = '';

  const count = result.filter(res => res === 0);

  if (count.length >= 3) {
    statusColor = '#cf202c';
    statusIcon = 'dislike';
  } else if (count.length >= 1) {
    statusColor = '#ffac00';
    statusIcon = 'like';
  } else if (count.length === 0) {
    statusColor = '#4eb476';
    statusIcon = 'like';
  }

  return (
    <div className={'swiper-slide__result swiper-slide-matriz'}>
      <div
        className={'swiper-slide__header'}
        style={{ backgroundColor: statusColor }}
      >
        <Icon
          type={statusIcon}
        />
        <div className={'swiper-slide__header-title'}>{title}</div>
      </div>

      <div className={'swiper-slide__body'}>
        <h2 className={'sidebar__main-question'}>&nbsp;</h2>

        <h3 className={'sidebar__sub-question'}>&nbsp;</h3>

        {result.map((item, index) =>
          index > 0 && (
            <div
              className={'swiper-slide__answer-wrapper'}
              key={index}
            >
              <div className={'swiper-slide__answer'}>
                {
                  (item === 0 ? (
                    <p
                      className={'swiper-slide__answer-text'}
                      style={{ color: '#cf202c' }}
                    >
                      <FormattedMessage id="slick.no"/>
                    </p>
                  ) : (
                      <p className={'swiper-slide__answer-text'}>
                        <FormattedMessage id="slick.yes"/>
                      </p>
                    ))
                }
              </div>
              {index === 4 && (<h3 className={'sidebar__sub-question'}>&nbsp;</h3>)}

              {index === 7 && (<><h2 className={'sidebar__main-question main-question-two'}>&nbsp;</h2><h3 className={'sidebar__sub-question sub-question-three'}>&nbsp;</h3></>)}

              {index === 10 && (<h3 className={'sidebar__sub-question sub-question-four'}>&nbsp;</h3>)}

              {index === 13 && (<><h2 className={'sidebar__main-question main-question-three page-break-before'}>&nbsp;</h2><h3 className={'sidebar__sub-question sub-question-five'}>&nbsp;</h3></>)}

              {index === 15 && (<h3 className={'sidebar__sub-question sub-question-six'}>&nbsp;</h3>)}
            </div>
          )
        )}
      </div>
    </div>
  );
};

ResultMatriz.propTypes = {
  id: number.isRequired
};

export default ResultMatriz;
